import { get, writable } from 'svelte/store';
import featuresJSON from '../../../../../features.json';
import { FeaturesManager, type FeatureType } from '@automapa/svelte-automapa-features-manager';

export let fm = writable(new FeaturesManager(featuresJSON));

// get(fm).setDescription(
//     'feature_1212_manual_add_job',
//     '(2024-03-20) #1212 Ręczne dodawanie zlecenia (bez makiety)'
// );
// // get(fm).setDescription('feature_1253_dashboard', '(2024-04-04) #1253 Dashboard (wg analytics)');
// get(fm).setDescription(
//     'feature_1355_auto_confirm',
//     '(2024-04-14) Automatyczne zatwierdzania reguł planu taktycznego (opcja do włączenia)'
// );

// export const feature_1212_manual_add_job = writable<boolean>(
//     get(fm).isEnabled('feature_1212_manual_add_job')
// );
// export const feature_1253_dashboard = writable<boolean>(
//     get(fm).isEnabled('feature_1253_dashboard')
// );
// export const feature_1355_auto_confirm = writable<boolean>(
//     get(fm).isEnabled('feature_1355_auto_confirm')
// );

fm.subscribe(value => {
    // feature_1212_manual_add_job.set(value.isEnabled('feature_1212_manual_add_job'));
    // feature_1253_dashboard.set(value.isEnabled('feature_1253_dashboard'));
    // feature_1355_auto_confirm.set(value.isEnabled('feature_1355_auto_confirm'));
});

export const features = writable<FeatureType>(get(fm).getFeatures());
features.subscribe(value => {
    Object.keys(value).forEach(key => {
        get(fm).setEnabled(key, value[key]);
    });
});
